import * as NavConstants from 'constants/NavConstants';
import {isSearchableSsiType} from 'constants/RegistryConstants';
import {getSelectedPageSize} from 'nav/sidepanel/PageSizeUtil';
import {ALL_LISTABLE_TYPES, Filter, FilterKey, keyToEmptyFilter, SearchParams} from 'search/SearchConstants';
import * as SearchPreferences from 'search/SearchPreferences';
import isModelTypeEnabledForListing from 'util/isModelTypeEnabledForListing';

export function isModelTypeEnabledForFiltering(type: string): boolean {
  return isModelTypeEnabledForListing(type) && !isSearchableSsiType(type);
}

// The types global search covers when the user hasn't filtered by type. The omnibox searches these
// too, so gating a type here gates it in both.
export function getDefaultSearchTypes(): Array<string> {
  return ALL_LISTABLE_TYPES.filter((type) => isModelTypeEnabledForFiltering(type));
}

function getDefaultSearchSearchFilters(): Array<Filter> {
  const filters: [Filter] = [
    {
      ...keyToEmptyFilter(FilterKey.TYPES),
      value: getDefaultSearchTypes(),
    },
  ];
  return filters;
}

export function getDefaultSearchSearchParams(): SearchParams {
  return {
    filters: getDefaultSearchSearchFilters(),
    offset: 0,
    limit: getSelectedPageSize(),
    query: '',
    sorts: SearchPreferences.getAppliedSortsFromUserPreference(NavConstants.Section.SEARCH),
    nextToken: null,
    groupBy: null,
  };
}
